import { ReactFlowProvider, ReactFlow, Node } from "@xyflow/react";
import { useAtomValue } from "jotai";
import {
  nodesAtom,
  edgesAtom,
  nodeAtomFamily,
  ZapNodeData,
} from "@zapier/canvas-state";

import { PreviewProvider } from "../../../context/PreviewProvider";
import { ZapNode } from "../nodeTypes/ZapNode";
import { ZapStepNode } from "../nodeTypes/ZapStepNode";
import { ZapStepEdge } from "../edgeTypes/ZapStepEdge";

export function ZapPreview({ nodeId }: { nodeId: string }) {
  const node = useAtomValue(nodeAtomFamily(nodeId)) as Node<ZapNodeData>;
  const nodes = useAtomValue(nodesAtom);
  const edges = useAtomValue(edgesAtom);
  const revealedZapSteps = nodes
    .filter(
      (node) => node.type === "zapStep" && node.data.zapId === node.data.zapId,
    )
    .map((node) => ({ ...node, hidden: false }));

  const edgesForZapSteps = edges
    .filter(
      (edge) =>
        edge.source.includes(node.data.zapId!) ||
        edge.target.includes(node.data.zapId!),
    )
    .map((edge) => ({
      ...edge,
      hidden: false,
    }));

  if (node.type !== "zap") {
    // TODO: implement preview for other types
    return null;
  }
  return (
    <ReactFlowProvider>
      <PreviewProvider value={true}>
        <ReactFlow
          panOnDrag={false}
          panOnScroll={false}
          zoomOnScroll={false}
          zoomOnPinch={false}
          nodes={[
            { ...node, selected: false },
            ...revealedZapSteps.filter((step) => step.parentId === node.id),
          ]}
          edges={[
            ...edgesForZapSteps.filter(
              (edge) =>
                edge.source.includes(node.data.zapId!) ||
                edge.target.includes(node.data.zapId!),
            ),
          ]}
          fitView
          nodeTypes={{
            zap: ZapNode,
            zapStep: ZapStepNode,
          }}
          edgeTypes={{
            zapStepEdge: ZapStepEdge,
          }}
          proOptions={{ hideAttribution: true }}
        />
      </PreviewProvider>
    </ReactFlowProvider>
  );
}
